import { useContext } from "react";
import { useSelector } from "react-redux";
import { AppContext } from "../../Context";
import { StoreState } from "../../store/rootReducer";
import Loader from "../genericComponents/Loader/Loader";
import SearchItem from "./SearchItem";
import "./SearchResults.css";
import { findAndSelectFeature } from "../../utils/arcgisUtils";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import type Graphic from "@arcgis/core/Graphic";
import type { ResourceHandle } from "@arcgis/core/core/Handles";

interface ClickResultsContentProps {
    storeHighlightHandle: (handle: ResourceHandle | null) => void;
    clearHighlightedFeatures: () => void;
}

const ClickResultsContent = (props: ClickResultsContentProps) => {
    const { storeHighlightHandle, clearHighlightedFeatures } = props;

    const appContext = useContext(AppContext);
    const clickResults = appContext?.clickResults.value ?? [];

    const clickResultsLoading = useSelector((state: StoreState) => state.search.clickResultsLoading);

    const fetchAndSetAccurateFeature = async (feature: Graphic, type: "show" | "edit") => {
        const layer = feature.layer;
        if (!layer) {
            console.error("Feature layer not found for the clicked feature.");
            return;
        }
        if (layer.type !== "feature") {
            console.error("Layer is not a feature layer.");
            return;
        }

        if (type === "edit") {
            findAndSelectFeature((layer as FeatureLayer), feature, (foundFeature) => {
                appContext?.selectedFeature.set(foundFeature)
            });
        }
        if (type === "show") {
            findAndSelectFeature((layer as FeatureLayer), feature, (foundFeature) => {
                appContext?.shownFeature.set(foundFeature);
            });
        }
    }

    return (
        <>
            <div className="search-content">
                {clickResults.length === 0 && !clickResultsLoading && <span>Ingen resultater funnet.</span>}
                {clickResults.map((result) => {
                    return (
                        <SearchItem
                            key={result.attributes.objectid}
                            feature={result}
                            storeHighlightHandle={storeHighlightHandle}
                            clearHighlightedFeatures={clearHighlightedFeatures}
                            customSelectFunction={(feature, type) => { fetchAndSetAccurateFeature(feature, type) }}
                        />
                    );
                })}
            </div>
            {clickResultsLoading && (
                <div className="search-loader">
                    <Loader inline size={20} />
                </div>
            )}
        </>
    );
};

export default ClickResultsContent;
